module.exports = __webpack_public_path__ + "fa-solid-900.f9b85c9463af7103b9b2.woff2";


//////////////////
// WEBPACK FOOTER
// /var/data/workspace/hess/hess_smart_city_web/src/assets/fonts/fa-solid-900.woff2
// module id = ../../../../../src/assets/fonts/fa-solid-900.woff2
// module chunks = styles